import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import AiChat from './AiChat';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AiAccordion = ({ data }) => {
  return (
    <Accordion
      sx={{
        my: '4rem',
        '&:before': {
          height: '0px',
        },
      }}
    >
      <AccordionSummary
        sx={{
          '&.MuiAccordionSummary-root': { bgcolor: '#efefef' },
        }}
        aria-controls="ai-help"
        id="ai-header"
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography sx={{ fontWeight: 500 }}>AI Assist</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: 'transparent' }}>
        <AiChat initialData={data} />
      </AccordionDetails>
    </Accordion>
  );
};

export default AiAccordion;
